import { createFileRoute } from '@tanstack/react-router';

import { legalPersonListScreen, legalPersonListSearch, loadPersonMessages, loadPersonScreens } from '@/modules/person/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/pessoas-juridicas/todas/')({
  validateSearch: legalPersonListSearch,
  staticData: { screen: legalPersonListScreen },
  loader: () => loadPersonMessages(),
  component: lazyScreen(loadPersonScreens, 'LegalPersonListScreen'),
});
